.vendor-lead-billing-info-done__layout {
  flex: 1;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: stretch;
}

.vendor-lead-billing-info-done__layout .vendor-lead-billing-info-done__layout__left {
  flex: 1;
}

.vendor-lead-billing-info-done__layout .vendor-lead-billing-info-done__layout__center {
  flex: 3;
  margin-right: 42px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
  align-items: flex-start;
}

.vendor-lead-billing-info-done__layout .vendor-lead-billing-info-done__layout__right {
  flex: 4;

  & video {
    object-fit: cover;
  }
}

.vendor-lead-billing-info-done__layout .vendor-lead-billing-info-done__layout__center__header {
  margin-top: 62px;
}

.vendor-lead-billing-info-done__layout__center__header .vendor-lead-billing-info-done__layout__center__header__logo {
  position: relative;

  width: 154px; // logo text width + logo text left
}

.vendor-lead-billing-info-done__layout__center__header .vendor-lead-billing-info-done__layout__center__header__logo-icon {
  border-radius: 50%;
  width: 40px;
  height: 40px;

  background-color: #22BDFF;
}

.vendor-lead-billing-info-done__layout__center__header .vendor-lead-billing-info-done__layout__center__header__logo-text {
  position: absolute;

  top: 14px;
  left: 10px;

  height: 14px;
  width: 140px;
}

.vendor-lead-billing-info-done__layout__center .vendor-lead-billing-info-done__layout__center__content {
  flex: 1;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;

  gap: 16px;
}

.vendor-lead-billing-info-done__layout__center .vendor-lead-billing-info-done__layout__center__title {
  font-size: 30px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.75px;

  text-align: left;
}

.vendor-lead-billing-info-done__layout__center .vendor-lead-billing-info-done__layout__center__text {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.vendor-lead-billing-info-done__layout__center .vendor-lead-billing-info-done__layout__center__footer {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

.vendor-lead-billing-info-done__layout__center .vendor-lead-billing-info-done__layout__center__footer__done-button {
  display: flex;
  flex-flow: row-reverse nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

@media screen and (width <=640px) {
  .vendor-lead-billing-info-done__layout {
    padding: 16px;
  }

  .vendor-lead-billing-info-done__layout .vendor-lead-billing-info-done__layout__left {
    display: none;
  }

  .vendor-lead-billing-info-done__layout .vendor-lead-billing-info-done__layout__center {
    margin-right: 0;
  }

  .vendor-lead-billing-info-done__layout .vendor-lead-billing-info-done__layout__right {
    display: none;
  }

  .vendor-lead-billing-info-done__layout .vendor-lead-billing-info-done__layout__center__header {
    margin-top: 0;

    align-self: stretch;

    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
  }

  .vendor-lead-billing-info-done__layout__center .vendor-lead-billing-info-done__layout__center__footer {
    flex-flow: column nowrap;
    align-items: stretch;
  }

  .vendor-lead-billing-info-done__layout__center .vendor-lead-billing-info-done__layout__center__footer__done-button {
    align-self: flex-end;
  }
}